import * as actionTypes from '../actions/Actions';

export const initialState = {
    data: {
        isOpen: false,
        customerId: '',
        contractId: '',
        feature: '',
        onEcom: null,
        cvv2: '',
        newPin: '',
        oldPin: '',
        sourceNumber: null,
        targetNumber: '',
        message: '',
        amount: '',
        bankCode: '',
        updateBal: null,
        variables: null,
    },
};

// ==============================|| Otp REDUCER ||============================== //

const otpReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SHOW_OTP_MODAL:
            return {
                ...state,
                data: {
                    ...state.data,
                    isOpen: true,
                    customerId: action.customerId,
                    contractId: '',
                    feature: action.feature,
                    onEcom: null,
                    cvv2: ''
                }
            };
        case actionTypes.CLOSE_OTP_MODAL:
            return {
                ...state,
                data: {
                    ...state.data,
                    isOpen: false,
                    customerId: '',
                    feature: '',
                    newPin: '',
                    oldPin: '',
                    sourceNumber: '',
                    targetNumber: '',
                    message: '',
                    amount: '',
                    bankCode: '',
                    onEcom: null,
                    updateBal: null
                }
            };
        case actionTypes.SHOW_OTP_MODAL_CARD_OPERATION:
            return {
                ...state,
                data: {
                    ...state.data,
                    isOpen: true,
                    contractId: action.contractId,
                    feature: action.feature,
                    onEcom: null,
                }
            };
        case actionTypes.SHOW_OTP_MODAL_CHANGE_PIN:
            return {
                ...state,
                data: {
                    ...state.data,
                    isOpen: true,
                    contractId: action.contractId,
                    newPin: action.newPin,
                    oldPin: action.oldPin,
                    feature: action.feature,
                }
            }
        case actionTypes.SHOW_OTP_MODAL_SET_PIN:
            return {
                ...state,
                data: {
                    ...state.data,
                    isOpen: true,
                    contractId: action.contractId,
                    newPin: action.newPin,
                    oldPin: '',
                    feature: action.feature,
                }
            }
        case actionTypes.SHOW_OTP_MODAL_INTRABANK_TRANSFER:
            return {
                ...state,
                data: {
                    ...state.data,
                    isOpen: true,
                    sourceNumber: action.sourceNumber,
                    targetNumber: action.targetNumber,
                    message: action.message,
                    amount: action.amount,
                    feature: action.feature
                }
            }
        case actionTypes.SET_ECOMMERCE_ON:
            return {
                ...state,
                data: {
                    ...state.data,
                    onEcom: true
                }
            };
        case actionTypes.SET_ECOMMERCE_OFF:
            return {
                ...state,
                data: {
                    ...state.data,
                    onEcom: false
                }
            }
        case actionTypes.SET_CVV2:
            return {
                ...state,
                data: {
                    ...state.data,
                    cvv2: action.cvv2
                }
            }
        case actionTypes.RESET_CVV2:
            return {
                ...state,
                data: {
                    ...state.data,
                    cvv2: ''
                }
            }
        case actionTypes.RESET_ECOM:
            return {
                ...state,
                data: {
                    ...state.data,
                    onEcom: null
                }
            }
        case actionTypes.UPDATE_BALANCE:
            return {
                ...state,
                data: {
                    ...state.data,
                    updateBal: true
                }
            }
        case actionTypes.SHOW_OTP_MODAL_TRANSFER_247:
            return {
                ...state,
                data: {
                    ...state.data,
                    isOpen: true,
                    sourceNumber: action.sourceNumber,
                    targetNumber: action.targetNumber,
                    message: action.message,
                    amount: action.amount,
                    bankCode: action.bankCode,
                    feature: action.feature
                }
            }
        case actionTypes.SHOW_OTP_MODAL_SET_USAGE_LIMTER:
            return {
                ...state,
                data: {
                    ...state.data,
                    isOpen: true,
                    variables: action.variables,
                    feature: action.feature,
                }
            }
        default:
            return state;
    }
};

export default otpReducer;
